import React, { useState } from "react";
import { MANAGER_ACCOUNT_USER_REMOVE } from "const/apiMethods";
import { useWindowWidth } from "hooks";
import { api } from "api/loginRoutes";
import { Modal } from "components/Modal";


export default ({
    show,
    onClose,
    userId,
    maxWidth = 600,
    onUpdate,
    ...props
}) => {

    const resizedWidth = useWindowWidth();
    const [loading, setLoading] = useState(false);

    const handleSuccess = () => {
        if (!userId) {
            return;
        }

        setLoading(true);
        api(MANAGER_ACCOUNT_USER_REMOVE, { target: { account_user_id: userId } })
            .then(() => {
                onUpdate && onUpdate();
                onClose();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Modal
            {...{ show, onClose }}
            onClose={() => onClose(false)}
            title={`Remove User`}
            width={resizedWidth > maxWidth ? maxWidth : resizedWidth}
            footer={true}
            disabled={loading}
            onSuccessClose={false}
            successText="Yes"
            focusTarget="close"
            onSuccess={handleSuccess}
            {...props}
        >
            Are you sure?
        </Modal>
    );
};